export default function ($translate, $rootScope) {
    const loadEnums = () => {
        return {
            KEYS: {
                CLASSIFIER_VIEW: 'CLASSIFIER_VIEW',
                APPLICATION_CREATE: 'APPLICATION_CREATE',
                MY_COURSE_VIEW: 'MY_COURSE_VIEW',
                MY_OCCURRENCE_TRAINING_VIEW: 'MY_OCCURRENCE_TRAINING_VIEW',
                MY_OPTIONAL_COURSE_SELF_REGISTER_CREATE: 'MY_OPTIONAL_COURSE_SELF_REGISTER_CREATE',
                MY_TRAINING_TIME_SELF_REGISTER_MANAGE: 'MY_TRAINING_TIME_SELF_REGISTER_MANAGE',
                MY_TRAINING_TIME_ICAL_VIEW: 'MY_TRAINING_TIME_ICAL_VIEW',
                MY_SCORM_COURSE_VIEW: 'MY_SCORM_COURSE_VIEW',
                MY_SCORM_COURSE_MANAGE: 'MY_SCORM_COURSE_MANAGE',
                MY_GUIDANCE_PARTICIPATE: 'MY_GUIDANCE_PARTICIPATE'
            },
            LABELS: {
                CLASSIFIER_VIEW: $translate.instant('role.privilege.employee.classifierView'),
                APPLICATION_CREATE: $translate.instant('role.privilege.employee.applicationCreate'),
                MY_COURSE_VIEW: $translate.instant('role.privilege.employee.myCourseView'),
                MY_OCCURRENCE_TRAINING_VIEW: $translate.instant('role.privilege.employee.myOccurrenceTrainingView'),
                MY_OPTIONAL_COURSE_SELF_REGISTER_CREATE: $translate.instant('role.privilege.employee.myOptionalCourseSelfRegisterCreate'),
                MY_TRAINING_TIME_SELF_REGISTER_MANAGE: $translate.instant('role.privilege.employee.myTrainingTimeSelfRegisterManage'),
                MY_TRAINING_TIME_ICAL_VIEW: $translate.instant('role.privilege.employee.myTrainingTimeIcalView'),
                MY_SCORM_COURSE_VIEW: $translate.instant('role.privilege.employee.myScormCourseView'),
                MY_SCORM_COURSE_MANAGE: $translate.instant('role.privilege.employee.myScormCourseManage'),
                MY_GUIDANCE_PARTICIPATE: $translate.instant('role.privilege.myGuidanceParticipate')
            }
        };
    };

    const enums = loadEnums();

    $rootScope.$on('$translateChangeSuccess', () => {
        enums.LABELS = loadEnums().LABELS;
    });
    return enums;
}



// WEBPACK FOOTER //
// ./src/app/enums/role/privilege/employee/index.js